// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3iAAe","fileBtn":"File_fileBtn__3xxH-","closeBtn":"File_closeBtn__PPXx4","fileSelected":"File_fileSelected__XlPzs","disabled":"File_disabled__bjV7S"};